module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedBlack.f6495a1.woff2";